import { render, staticRenderFns } from "./FaceDirectionResultEffect.vue?vue&type=template&id=7f3def55&scoped=true&"
import script from "./FaceDirectionResultEffect.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffect.vue?vue&type=script&lang=ts&"
import style0 from "./FaceDirectionResultEffect.vue?vue&type=style&index=0&id=7f3def55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3def55",
  null
  
)

export default component.exports